import React from "react";
import { CorrectIcon, DisableCorrectIcon } from "../../icon";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"

interface IProps {
  passwordCheck: string;
  IsMobileDevice: boolean;
}

const PasswordRequirements: React.FunctionComponent<IProps> = (props) => {
  const IsDarkMode = useSelector(selector.isDarkMode)
  const hasNumber = () => {
    return new RegExp(/[0-9]/).test(props.passwordCheck);
  }
  const hasCapitlaletter = () => {
    return new RegExp(/[A-Z]/).test(props.passwordCheck);
  }
  const hasSmallletter = () => {
    return new RegExp(/[a-z]/).test(props.passwordCheck);
  }
  const hasSpecialCharacter = () => {
    return new RegExp(/[!~#@$%^&*`)(+=._-]/).test(props.passwordCheck);
  }
  const hasLength = () => {
    if (props.passwordCheck.length >= 8 && props.passwordCheck.length <= 20) {
      return true
    }
    return false
  }
  return (
    <div className={`d-flex flex-direction justify-between t-align-initial h6`}>
      <div className={` ${props.IsMobileDevice ? '' : ' mb-2'} color-changepassword-fields h4-medium`}> Password must contain the following:</div>
      <div className={`${props.IsMobileDevice ? "h4 color-changepassword-fields mt-1" : "h4-regular color-changepassword-fields-heading mt-3"} d-flex align-center`}>
        {hasLength() ? <CorrectIcon className="mr-1" /> : <DisableCorrectIcon className="mr-1" />}
        <span className={`${hasLength() ? "color-changepassword-error-checks" : IsDarkMode ? "color-changepassword-fields" : ""}`}>Must be between 8 and 20 characters.</span>
      </div>
      <div className={`${props.IsMobileDevice ? "h4 color-changepassword-fields" : "h4-regular color-changepassword-fields-heading "} d-flex align-center  mt-1`}>
        {hasCapitlaletter() ? <CorrectIcon className="mr-1" /> : <DisableCorrectIcon className="mr-1" />}
        <span className={`${hasCapitlaletter() ? "color-changepassword-error-checks" : IsDarkMode ? "color-changepassword-fields" : ""}`}>At least 1 uppercase letter.</span>
      </div>
      <div className={`${props.IsMobileDevice ? "h4  color-changepassword-fields" : "h4-regular color-changepassword-fields-heading "} d-flex align-center mt-1`}>
        {hasSmallletter() ? <CorrectIcon className={"mr-1"} /> : <DisableCorrectIcon className={"mr-1"} />}
        <span className={`${hasSmallletter() ? "color-changepassword-error-checks" : IsDarkMode ? "color-changepassword-fields" : ""}`}>At least 1 lowercase letter.</span>
      </div>
      <div className={`${props.IsMobileDevice ? "h4  color-changepassword-fields" : "h4-regular color-changepassword-fields-heading "} d-flex align-center mt-1`}>
        {hasNumber() ? <CorrectIcon className={"mr-1"} /> : <DisableCorrectIcon className={"mr-1"} />}
        <span className={`${hasNumber() ? "color-changepassword-error-checks" : IsDarkMode ? "color-changepassword-fields" : ""}`}>At least 1 number</span>
      </div>
      <div className={`${props.IsMobileDevice ? "h4 color-color-changepassword-fields" : "h4-regular color-changepassword-fields-heading "} d-flex align-center mt-1`}>
        {hasSpecialCharacter() ? <CorrectIcon className={"mr-1"} /> : <DisableCorrectIcon className={"mr-1"} />}
        <span className={`my-auto ${hasSpecialCharacter() ? "color-changepassword-error-checks" : IsDarkMode ? "color-changepassword-fields" : ""} `}>At least 1 special character</span>
      </div>
    </div>
  )
}
export default PasswordRequirements
